import React from 'react';
import PropTypes from 'prop-types';

import { Snackbar } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';

import MySnackbarContentWrapper from "../childrens/wrapper/.mixins";

//css
import StylesCss from './styles';

MySnackbarContentWrapper.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['error', 'info', 'success', 'warning']).isRequired,
};

class ConsecutiveSnackbars extends React.Component {
  queue = [];

  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };

    this.retorno = this.retorno.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  retorno = (message, type) => {
    this.queue.push({
      message: message,
      type: type,
      key: new Date().getTime(),
      duration: 3000
    });

    if (this.state.open) {
      this.setState({ open: false });
    } else {
      this.processQueue();
    }
  }

  retornoWithoutAutoClose = (message, type) => {
    this.queue.push({
      message: message,
      type: type,
      key: new Date().getTime(),
      duration: null
    });

    if (this.state.open) {
      this.setState({ open: false });
    } else {
      this.processQueue();
    }
  }

  handleClick = message => () => {
    this.queue.push({
      message,
      type: 'error',
      key: new Date().getTime(),
    });

    if (this.state.open) {
      this.setState({ open: false });
    } else {
      this.processQueue();
    }
  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ open: false });
  };

  processQueue = () => {
    if (this.queue.length > 0) {
      this.setState({
        messageInfo: this.queue.shift(),
        open: true,
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { messageInfo = {} } = this.state;

    if (messageInfo.type == null)
      messageInfo.type = 'error';

    return (
      <div>
        <Snackbar
          key={messageInfo.key}
          open={this.state.open}
          autoHideDuration={messageInfo.duration}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          TransitionProps={{
            appear: false,
          }}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
        >
          <MySnackbarContentWrapper
            onClose={this.handleClose}
            variant={messageInfo.type}
            message={messageInfo.message}
          />
        </Snackbar>
      </div>
    );
  }
}

ConsecutiveSnackbars.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(StylesCss)(ConsecutiveSnackbars);